<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cs6q60/tc-custom/9781466839953.jpg?1737365696469" alt="This image is the cover for the book Diana"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Diana
      </h1>
      <p class="bookDescription body article font2">
        <p>On New Year's Eve in 1969, a novelist in his forties meets the beautiful movie actress Diana Soren at a party and is fascinated by her oddly elusive charm. But in this novel from Carlos Fuentes, his infatuation turns into doomed pursuit as the fleeting object of his desire spurns him, and he is forced to reconsider the foundations of his life as a writer.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carlos Fuentes
      </h2>
      
      <p class="authorDescription body article"><P><B>Carlos Fuentes (1928-2012)</B> was one of the most influential and celebrated voices in Latin American literature. He was the author of 24 novels, including <I>The Death of Artemio Cruz</I>, <I>The Old Gringo</I> and <I>Terra Nostra</I>, and also wrote numerous plays, short stories, and essays. He received the 1987 Cervantes Prize, the Spanish-speaking world's highest literary honor. <br><br>Fuentes was born in Panama City, the son of Mexican parents, and moved to Mexico as a teenager. He served as an ambassador to England and France, and taught at universities including Harvard, Princeton, Brown and Columbia. He died in Mexico City in 2012.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f1ce790a